import type { EdgeId, NodeSn } from '@ipfabric/utils';
import type { PathLookupPathInspectorSelectedPacketSource } from 'components/DeviceView/deviceViewTypes';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { selectPathInspectorForwardedPacket } from './selectPathInspectorForwardedPacket';
import { selectPathInspectorTerminatedPacket } from './selectPathInspectorTerminatedPacket';

export interface SelectPathInspectorPacketCommand {
  nodeSn: NodeSn;
  packetId: EdgeId;
  packetSource: PathLookupPathInspectorSelectedPacketSource;
}

export const selectPathInspectorPacket: GraphCommandFactory<
  SelectPathInspectorPacketCommand
> = (_cmdContext, dispatch) => (command) => {
  if (
    command.packetSource === 'edge' ||
    command.packetSource === 'generatedPackets'
  ) {
    dispatch(selectPathInspectorForwardedPacket, {
      edgeId: command.packetId,
      nodeSn: command.nodeSn,
      packetSource: command.packetSource,
    });
  } else {
    dispatch(selectPathInspectorTerminatedPacket, {
      nodeSn: command.nodeSn,
      packetId: command.packetId,
      packetSource: command.packetSource,
    });
  }
};
